import { AppsPermissionService } from '@prodcard/core'
import { translationService } from './translation'

// check permissions on app side
export const permissionsService = new AppsPermissionService({ translationService })
